"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestLogToJSONTyped = exports.RequestLogToJSON = exports.RequestLogFromJSONTyped = exports.RequestLogFromJSON = exports.instanceOfRequestLog = void 0;
/**
 * Check if a given object implements the RequestLog interface.
 */
function instanceOfRequestLog(value) {
    if (!('action' in value) || value['action'] === undefined)
        return false;
    return true;
}
exports.instanceOfRequestLog = instanceOfRequestLog;
function RequestLogFromJSON(json) {
    return RequestLogFromJSONTyped(json, false);
}
exports.RequestLogFromJSON = RequestLogFromJSON;
function RequestLogFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'action': json['action'],
        'params': json['params'] == null ? undefined : json['params'],
    };
}
exports.RequestLogFromJSONTyped = RequestLogFromJSONTyped;
function RequestLogToJSON(json) {
    return RequestLogToJSONTyped(json, false);
}
exports.RequestLogToJSON = RequestLogToJSON;
function RequestLogToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'action': value['action'],
        'params': value['params'],
    };
}
exports.RequestLogToJSONTyped = RequestLogToJSONTyped;
